import { animations } from './js/front/animations.js';
animations();
